class MediaQuery {
    isDesktop() {
        return (window.innerWidth >= 1200)
    }

    isBreakpointMD() {
        return (window.innerWidth >= 992 && window.innerWidth <= 1199)
    }

    isBreakpointSM() {
        return (window.innerWidth >= 768 && window.innerWidth <= 991)
    }

    isBreakpointXS() {
        return (window.innerWidth < 768)
    }

    isLessThan375() {
        return (window.innerWidth < 375)
    }
}

export default new MediaQuery();
